__webpack_require__.p = "/j2b_gui/";